import { c as _c } from "react/compiler-runtime";
interface SidebarItem {
  icon: React.ReactNode;
  text: string;
  component?: React.ReactNode;
  dataId?: string;
  action?: React.ReactNode;
}
interface SidebarProps {
  items: SidebarItem[];
}
type Props = {
  leftSidebar?: SidebarProps;
  rightSidebar?: SidebarProps;
  onItemClick: (item: SidebarItem) => void;
};
const MobileSidebarTriggers = t0 => {
  const $ = _c(13);
  const {
    leftSidebar,
    rightSidebar,
    onItemClick
  } = t0;
  if (!leftSidebar && !rightSidebar) {
    return null;
  }
  let t1;
  if ($[0] !== leftSidebar?.items || $[1] !== onItemClick) {
    t1 = leftSidebar?.items?.map(item => <button key={item.dataId ?? item.text} className="flex items-center gap-x-2 rounded p-2 hover:bg-background-light" onClick={() => onItemClick(item)}><span className="hidden md:block">{item.text}</span>{item.icon}</button>);
    $[0] = leftSidebar?.items;
    $[1] = onItemClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex space-x-2 laptop:hidden lg:hidden">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onItemClick || $[6] !== rightSidebar?.items) {
    t3 = rightSidebar?.items?.map(item_0 => <button key={item_0.dataId ?? item_0.text} className="flex items-center gap-x-2 rounded p-2 hover:bg-background-light" onClick={() => onItemClick(item_0)}><span className="hidden md:block">{item_0.text}</span>{item_0.icon}</button>);
    $[5] = onItemClick;
    $[6] = rightSidebar?.items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="flex w-full justify-end space-x-2 lg:hidden">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="mt-4 flex justify-between rounded-md p-2 lg:hidden">{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default MobileSidebarTriggers;